export const filterRecords = (records = [], term, customShape) => (
  term ? records.filter(filterByTerm(term, customShape)) : records
)

const filterByTerm = (term, customShape) => (record) => filterRecord(record, term, customShape)

const filterRecord = (record, term, customShape) => {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every

  // "The every method executes the provided callback function once for each
  //  element present in the array until it finds one where callback
  //  returns a falsy value.""

  // Since we want to test for a postive attribute, we'll negate this behaviour
  // here and in the matchValue method
  return !Object.values(customShape ? customShape(record) : record).every(matchValue(term))
}

const matchValue = (term) => (value = '') => (
  !String(value).match(new RegExp(`^${sanitisedTerm(term)}`, 'i'))
)

const sanitisedTerm = (term) => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string



// WEBPACK FOOTER //
// ./src/ui/list/filter.js